module.exports = __webpack_public_path__ + "img/map.5239cbbc.png";